import styled from "styled-components";
import { shade800 } from "../../styles/tokens";
import { BorderBar, Container, Content } from "../tab/Tab.Parts";

// TEXT

// STYLES
export const TabBar = styled.div`
  width: 100%;
  display: flex;
  position: relative;

  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  scrollbar-width: none;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    display: none;
  }

  &::before {
    left: 0;
    bottom: 0;
    width: 100%;
    content: "";
    height: 0.0625rem;
    position: absolute;
    background-color: ${shade800};
  }

  ${Container}:first-child {
    ${BorderBar} {
      margin-left: 0;
    }
    ${Content} {
      padding-left: 0;
    }
  }

  && {
    overflow: visible;
  }
`;

// DATA

// TYPES

// CONSTANTS

// FUNCTIONS

// ASSETS
